import type { ContractItem } from './contract-item'
import type { ContractStatus } from './contract-status'
import { SalesPerson } from './sales-person'

export class ContractGeneric {
	id: string = ''
	account: string = ''
	account_name: string = ''
	account_number: string = ''
	assigned_to: string = ''
	journey_date?: string = ''
	contract_number: string = ''
	link_number: string = ''
	depot: string = ''
	delivery_address_1: string = ''
	delivery_address_2: string = ''
	delivery_address_3: string = ''
	delivery_address_4: string = ''
	delivery_address_5: string = ''
	delivery_postcode: string = ''
	delivery_contact: string = ''
	delivery_date: string = ''
	delivery_number: string = ''
	delivery_email: string = ''
	delivery_telephone: string = ''
	hire_depot: string = ''
	sales_lead: SalesPerson = new SalesPerson()
	ordered_by: string = ''
	ordered_by_number: string = ''
	ordered_by_email: string = ''
	type: string = ''
	weight: string | number = ''
	notes: string = ''
	changed?: boolean = false
}

export class Contract extends ContractGeneric {
	object: string = 'Contract'
	status: Array<ContractStatus> = []
	items: Array<ContractItem> = []
}

/**
 * For use in places where a contract is returned
 * but we need to work with both Collections and Contracts
 */
export class CollectionContract extends Contract {
	assigned_to: string = ''
	collection_number: string = ''
	collection_date: string = ''
	passed_to_driver: boolean = false
}
